import { useState } from 'react'
import { Modal } from 'components'
import toast from 'react-hot-toast'
import { lang } from 'config'
import { useAuth } from "contexts/auth-context"
import { executeAPI } from "repositories/db-repository"
import { useSWRConfig } from "swr"
import { useNavigate } from "react-router-dom"

const Content = ({ data, success }) => {
  const { user } = useAuth()
  const [errors, setErrors] = useState({})
  const { cache } = useSWRConfig()
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    e.preventDefault()

    const onSuccess = (result, message) => {
      // Ambil status terbaru dari server
      const latest =
        result?.return_header?.[0]?.latest_flow_detail_id ||
        result?.return_header?.[0]?.flow_detail_id

      const current =
        data?.status || data?.latest_flow_detail_id || data?.flow_detail_id

      cache.clear()
      navigate({ pathname: '/return' })

      if (latest && latest !== current) {
        toast.success("Status return berhasil di-refresh!", { id: "submit" })
      } else {
        toast.error("Belum ada status terbaru!", { id: "submit" })
      }

      success?.()
    }

    const onError = (message) => {
      cache.clear()
      navigate({ pathname: '/return' })
      toast.error(message || "Gagal refresh", { id: "submit" })
    }

    if (data?.id) {
      toast.loading("Loading", { id: "submit" })

      // Ambil data & status terbaru dari server PS
      onSuccess()
    } else {
      setErrors({})
    }
  }

  const displayNumber = data?.return_number || data?.purchase_number || data?.id

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-8">
      {lang.are_you_sure_you_want_to_refresh}{" "}
      <span className="inline-flex px-3 py-1 text-sm font-medium rounded-xl bg-neutral-200 text-neutral-600">
        {displayNumber}
      </span>{" "}
      ?
      <div className="text-xs">
        <button
          type="submit"
          className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90"
        >
          <span>{lang.yes}</span>
        </button>
      </div>
    </form>
  )
}

const Refresh = ({ data, onSuccess }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  const handleSuccess = () => {
    closeModal()
    onSuccess?.()
  }

  // deteksi status sekarang (support beberapa nama field)
  const statusNow = data?.status || data?.latest_flow_detail_id || data?.flow_detail_id

  // aturan enable refresh (silakan sesuaikan kalau mau)
  const canRefresh = [
    "RETURN_DRAFT",
    "RETURN_NEED_REVIEW",
    "RETURN_IN_REVIEW",
    "RETURN_APPROVED"
  ].includes(statusNow)

  return (
    <>
      <button
        disabled={!canRefresh}
        onClick={canRefresh ? openModal : () => {}}
        className={`${!canRefresh ? 'opacity-50 bg-red-900' : 'bg-red-800'} inline-flex items-center p-1 text-white transition rounded-full active:hover:scale-90`}
        title="Refresh Status"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width={24} height={24} viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
          <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
        </svg>
      </button>

      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        title={`${lang.refresh} ${lang.status}`}
        content={<Content data={data} success={handleSuccess} />}
      />
    </>
  )
}

export default Refresh
